import React from "react";
import {Box, Skeleton, Stack} from "@mui/material";

interface CampaignCardCarouselSkeletonProps {
  count: number;
  isLoading: boolean;
}

const CampaignCardCarouselSkeleton = ({
  count,
  isLoading
}: CampaignCardCarouselSkeletonProps) => {
  const skeletons = Array.from({length: count}).map((_, i) => (
    { id: `campaign-skeleton-${i}`}
  ));

  let skeletonWidth: string | object = { xs: "350px", sm: "466px", md: "610px", lg: "700px" };
  if(count === 1){
    skeletonWidth = "100%";
  }
  else if(count === 2){
    skeletonWidth = { xs: "300px", sm: "400px", md: "550px", lg: "610px" };
  }

  return (
    <Box width="100%">
      <Stack
        direction="row"
        gap="2rem"
        data-testid="campaign-carousel-skeleton"
        sx={{
          width: "144rem",
          marginTop: "2rem",
          justifySelf: "center",
          justifyContent: "center",
          overflow: "hidden",
          display: isLoading ? "flex" : "none"
        }}
      >
        {skeletons.map((skeleton) => (
          <Skeleton
            key={skeleton.id}
            variant="rounded"
            sx={{
              width: skeletonWidth,
              borderRadius: "1.25rem",
              height: {xs:"385px", sm: "404px"},
              flexShrink: 0
            }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default CampaignCardCarouselSkeleton;